// frontend/src/samkalp-admin/SamkalpAdmin.js
//
// Root auth gate for the unified Samkalp Admin Dashboard, mirroring the
// SamkalpAskOS.js pattern. Persists slug alongside access_token (in its own
// localStorage key) since this dashboard isn't reached via a /tenant/:slug/*
// route, unlike Studio — so there's no URL param to recover it from on reload.
import React, { useState } from 'react';
import SamkalpAdminLoginPage from './SamkalpAdminLoginPage';
import SamkalpAdminDashboard from './SamkalpAdminDashboard';

const SamkalpAdmin = () => {
    const storedToken = localStorage.getItem('access_token');
    const storedSlug = localStorage.getItem('samkalp_admin_slug');
    const [session, setSession] = useState(
        storedToken && storedSlug ? { slug: storedSlug } : null
    );

    const handleLogout = () => {
        localStorage.removeItem('access_token');
        localStorage.removeItem('samkalp_admin_slug');
        setSession(null);
    };

    if (!session) return <SamkalpAdminLoginPage onLogin={sess => setSession(sess)} />;
    return <SamkalpAdminDashboard slug={session.slug} onLogout={handleLogout} />;
};

export default SamkalpAdmin;
